import * as React from "react";
import withStyles from "react-jss";
import * as classNames from "classnames";
import InlineSVG from "ComponentsUI/Inlinesvg";
import { svgStar } from "Constants/SVG";

const styles = (theme) => {
	return {
		root: {
			display: "block",
			position: "absolute",
			top: "12px",
			left: "12px",
			cursor: "pointer",
			"& .icon24": {
				color: theme.palette.colors.purplishBlue,
				fontSize: "18px",
				zIndex: 1,
				position: "relative",
				display: "block",
			},
			"& svg": {
				fill: theme.palette.colors.purplishBlue,
				width: "24px",
				height: "24px",
				zIndex: 1,
				"& path": {
					fill: theme.palette.colors.purplishBlue,
				},
			},
			"&:hover": {
				top: 0,
				left: "-1px",
				right: "-1px",
				"& .icon24": {
					display: "none",
					// margin: "12px 0 0 13px",
					// color: theme.palette.colors.white
				},
				"& svg": {
					// fill :  theme.palette.colors.white,
					display: "none",
				},
				"& $info": {
					top: 0,
					visibility: "visible",
					opacity: 1,
					zIndex: 1000,
				},
			},
		},
		info: {
			backgroundColor: theme.palette.colors.purplishBlue,
			top: 0,
			width: "100%",
			position: "absolute",
			transition: "opacity .15s ease",
			visibility: "hidden",
			opacity: 0,
			borderRadius: "10px 10px 0 0",
			zIndex: 0,
		},
		complexPlanView: {
			top: "47px",
			left: "2px",
		},
		text: {
			padding: "10px 30px",
			textAlign: "center",
			"& span": {
				fontFamily: theme.fonts.medium,
				fontSize: "14px",
				lineHeight: "1.29",
				color: theme.palette.colors.white,
				"&:last-child": {
					textDecoration: "line-through",
				},
			},
		},
		fakeBlock: {},
		rootFlat: {
			"& $info": {
				top: "-100px",
				width: "125px",
				borderRadius: `10px`,
				zIndex: 4,
			},
			"& $text": {
				textAlign: "center",
				padding: "14px 14px",
			},
			"&:hover": {
				"& .icon24": {
					color: theme.palette.colors.purplishBlue,
					margin: "12px 0 0 13px",
					display: "block",
				},
				"& $info": {
					top: "-4px",
					transform: "translateY(-100%)",
					visibility: "visible",
					opacity: "1",
					"&:after": {
						content: '""',
						position: "absolute",
						bottom: "-12px",
						left: "7px",
						width: 0,
						height: 0,
						borderStyle: "solid",
						borderWidth: "15px 15px 0 15px",
						borderColor: `${theme.palette.colors.purplishBlue} ${theme.palette.colors.transparent} ${theme.palette.colors.transparent} ${theme.palette.colors.transparent}`,
					},
				},
				"& $fakeBlock": {
					width: "100%",
					position: "absolute",
					bottom: "-30px",
					height: "30px",
					backgroundColor: theme.palette.colors.transparent,
				},
			},
		},
		rootFlatV2: {
			top: "20px",
			left: "10px",
			"& $info": {
				top: "-100px",
				width: "180px",
				borderRadius: `10px`,
				zIndex: 4,
				":hover": {
					$svg: {
						display: "block",
					},
				},
			},
			"& $text": {
				padding: "10px",
				textAlign: "center",
				"& span": {
					fontFamily: theme.fonts.bold,
					fontSize: "15px",
				},
			},
			"& svg": {
				width: "20px",
				height: "20px",
			},
			"&:hover": {
				left: "0px",
				right: "0",
				"& .icon24": {
					//     color: theme.palette.colors.purplishBlue,
					//     margin: "12px 0 0 13px",
					display: "block",
					top: "20px",
					left: "10px",
				},
				"& $info": {
					top: "0px",
					transform: "translateY(-100%)",
					visibility: "visible",
					opacity: "1",
					"&:after": {
						content: '""',
						position: "absolute",
						bottom: "-14px",
						left: "5px",
						width: 0,
						height: 0,
						borderStyle: "solid",
						borderWidth: "15px 15px 0 15px",
						borderColor: `${theme.palette.colors.purplishBlue} ${theme.palette.colors.transparent} ${theme.palette.colors.transparent} ${theme.palette.colors.transparent}`,
					},
				},
				"& $fakeBlock": {
					width: "100%",
					position: "absolute",
					bottom: "-30px",
					height: "30px",
					backgroundColor: theme.palette.colors.transparent,
				},
			},
		},
		rootPlans: {},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			rootFlatV2: {
				top: "14px",
				left: "5px",
				"& svg": {
					width: "16px",
					height: "16px",
				},
				"& $info": {
					borderRadius: "10px 10px 10px 5px",
				},
				"&:hover": {
					"& .icon24": {
						top: "14px",
						left: "5px",
					},
					"& $info": {
						"&:after": {
							left: "1px",
							bottom: "-10px",
							borderWidth: "12px 12px 0 12px",
						},
					},
				},
			},
			text: {
				padding: "3px 30px",
				textAlign: "center",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			rootFlatV2: {
				top: "10px",
				left: "5px",
				"& $info": {
					border: `1px solid ${theme.palette.colors.white}`,
					borderRadius: "10px 10px 10px 10px",
				},
				"&:hover": {
					"& .icon24": {
						top: "10px",
						left: "5px",
					},
					"& $info": {
						"&:after": {
							left: "4px",
							bottom: "-9px",
							borderWidth: "10px 10px 0 10px",
						},
					},
				},
			},
			text: {
				padding: "5px 30px",
			},
			rootPlans: {
				top: "6px",
				left: "6px",
				"&:hover": {
					"& .icon24": {
						margin: "6px 0 0 7px",
						color: theme.palette.colors.white,
					},
				},
			},
		},
	};
};

class ElitePopup extends React.Component {
	preventBehavior(e) {
		e.stopPropagation();
	}

	render() {
		let classes = this.props.classes;
		return (
			<div
				onClick={(e) => {
					this.preventBehavior(e);
				}}
				className={classNames(classes.root, {
					[classes.rootFlat]: this.props.flat,
					[classes.rootFlatV2]: this.props.flatV2,
					[classes.rootPlans]: this.props.plans,
					[classes.complexPlanView]: this.props.complexPlanView,
				})}
			>
				{!this.props.src && !this.props.flatV2 && <span className="icon24 icon-star" />}
				{!!this.props.src && <InlineSVG src={this.props.src} />}
				{this.props.flatV2 && (
					<svg className="icon24" width="24" height="24" viewBox={"0 0 24 24"}>
						<path d={svgStar}></path>
					</svg>
				)}
				<div className={classes.info}>
					<div className={classes.text}>
						<span>{this.props.text1}</span>
						<span>{this.props.text2}</span>
					</div>
					{this.props.flat && <div className={classes.fakeBlock} />}
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(ElitePopup);
